var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- Intentional*/
import { useCallback, useMemo, useReducer } from 'react';
import { initialFormContext } from '../../context';
import { FormActions } from '../../reducers';
export const useFormReducer = ({ flattenState, reducer, }) => {
    _react_refresh_temp_1();
    const [context, dispatch] = useReducer(reducer, initialFormContext);
    const { isValid, isValidating, value } = useMemo(() => {
        return flattenState(context.state);
    }, [context.state]);
    const removeFromForm = useCallback((payload) => {
        dispatch({
            payload,
            type: FormActions.REMOVE_FROM_FORM,
        });
    }, []);
    const setInForm = useCallback((payload) => {
        dispatch({
            payload,
            type: FormActions.SET_IN_FORM,
        });
    }, []);
    return {
        context,
        dispatch,
        isValid,
        isValidating,
        removeFromForm,
        setInForm,
        value,
    };
};
_react_refresh_temp_1(useFormReducer, "2nRZ9auK0yGYDw9a/cSPpZ/hF5s=");
